import React from "react";
import { View, StyleSheet, ScrollView, useWindowDimensions } from "react-native";
import CompanionILECard from "../CompanionILECard/CompanionILECard";
import type { CompanionILECardProps } from "../CompanionILECard/CompanionILECard";
import { spacing } from "../../../styles/design-system";

export interface CompanionILECardListProps {
  activities: CompanionILECardProps[];
  scrollable?: boolean;
  containerStyle?: object;
}

const CompanionILECardList: React.FC<CompanionILECardListProps> = ({
  activities,
  scrollable = false,
  containerStyle = {},
}) => {
  const { width } = useWindowDimensions();
  const cardMaxWidth = width < 600 ? "100%" : width < 900 ? "48%" : "32%";

  const content = (
    <View style={[styles.gridContainer, containerStyle]}>
      {activities.map((activity) => (
        <View key={activity.id} style={[styles.cardWrapper, { maxWidth: cardMaxWidth }]}>
          <CompanionILECard {...activity} />
        </View>
      ))}
    </View>
  );

  if (scrollable) {
    return (
      <ScrollView style={styles.scrollContainer} contentContainerStyle={styles.scrollContent}>
        {content}
      </ScrollView>
    );
  }

  return content;
};

const styles = StyleSheet.create({
  scrollContainer: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    width: "100%",
    alignItems: "stretch",
  },
  gridContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.sm,
    padding: spacing.sm,
    width: "100%",
    maxWidth: 1240,
  },
  cardWrapper: {
    flexBasis: 300,
    flexGrow: 1,
    flexShrink: 0,
  },
});

export default CompanionILECardList;
